<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div class="card dre-hero">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-md-8">
                                <span class="dre-kicker">Inteligência Financeira</span>
                                <h4 class="dre-title">Demonstrativo de resultados</h4>
                                <p class="dre-subtitle">Leitura consolidada do desempenho financeiro com detalhamento por conta.</p>
                            </div>
                            <div class="col-md-4 text-md-right">
                                <button type="button" class="btn btn-outline-primary btn-sm dre-action-btn" @click.prevent="mostrarFiltros = !mostrarFiltros">
                                    <i class="fa" :class="mostrarFiltros ? 'fa-eye-slash' : 'fa-sliders'"></i> {{ mostrarFiltros ? 'Ocultar filtros' : 'Escolher filtros' }}
                                </button>
                                <router-link to="/">
                                    <button type="button" class="btn btn-secondary btn-sm dre-action-btn"><i class="fa fa-reply"></i> Voltar</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="pnlista" class="card dre-filter-card">
                    <div class="card-header">
                        <span id="titlista"><i class="fa fa-filter"></i> Filtros de consulta</span>
                    </div> 
                    <div class="card-body" v-show="mostrarFiltros">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtfim">até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;"></select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Conta:</span>
                                <select id="cbconta" data-placeholder="Selecione uma opção" v-model="pidconta" data-allow-clear="true" style="width:100%;"></select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Grupo de conta:</span>
                                <select id="cbgrupoconta" data-placeholder="Selecione uma opção" v-model="pidgrupoconta" data-allow-clear="true" style="width:100%;"></select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Centro de custo:</span>
                                <select id="cbcentrocusto" data-placeholder="Selecione uma opção" v-model="pidcentrocusto" data-allow-clear="true" style="width:100%;"></select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2 d-flex align-items-end">                            
                                <div class="custom-control custom-switch border rounded w-100 dre-switch-wrap">
                                    <input type="checkbox" class="custom-control-input" id="cbdetalhartodos" v-model="pdetalhartodos" @change="mtddetalhartodos()">
                                    <label class="custom-control-label" for="cbdetalhartodos" id="lbldetalhartodos">Detalhar todos</label>
                                </div>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdimprimir()"><i class="fa fa-print"></i> Imprimir</button>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="lstreceitas.length > 0 || lstdespesas.length > 0">
                    <div class="row dre-kpis">
                        <div class="col-sm-12 col-md-4">
                            <div class="card dre-kpi-card dre-kpi-receita">
                                <div class="card-body">
                                    <span class="dre-kpi-title">Total receitas</span>
                                    <h5 class="dre-kpi-value">{{mtdformatavalordecimal(totalreceitas, 2)}}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card dre-kpi-card dre-kpi-despesa">
                                <div class="card-body">
                                    <span class="dre-kpi-title">Total despesas</span>
                                    <h5 class="dre-kpi-value">{{mtdformatavalordecimal(totaldespesas, 2)}}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card dre-kpi-card dre-kpi-liquido">
                                <div class="card-body">
                                    <span class="dre-kpi-title">Resultado líquido</span>
                                    <h5 class="dre-kpi-value" :class="parseFloat(totaldif) > 0 ? 'text-receitas' : 'text-despesas'">{{mtdformatavalordecimal(totaldif, 2)}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6">
                            <div class="card dre-result-card">
                                <div class="card-header"><i class="fa fa-plus-circle text-receitas"></i> Receitas</div>
                                <div class="card-body table-responsive">
                                    <table id="tbreceitas" class="table table-hover table-sm table-dre responsive">
                                        <tbody>
                                            <tr v-for="(receita, index) in lstreceitas" v-bind:key="index">
                                                <td class="font-weight-bold text-black-50" style="vertical-align: top;">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <i class="fa fa-plus-circle receitas" @click.prevent="mtddetalheitem(lstreceitas, index);"></i> {{receita.descgruconta}}
                                                        </div>
                                                        <template v-if="parseInt(receita.detalhar) === 1">
                                                            <div class="col-md-2"></div>
                                                            <div class="col-md-10">
                                                                <div class="table-responsive table-borderless">
                                                                    <table class="table table-hover table-sm table-dreresponsive">
                                                                        <tbody>
                                                                            <tr v-for="(movimento, indmov) in receita.movimentos" v-bind:key="indmov">
                                                                                <td class="font-weight-bold text-black-50 dre-subitem">{{movimento.descplano}}</td>
                                                                                <td class="font-weight-bold text-right receitas dre-subitem">{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                                <td width="50" class="text-right text-black-50 dre-subitem">{{mtdformatavalordecimal(movimento.totalmov / receita.totalmov * 100, 2)}}%</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </td>
                                                <td class="text-right text-receitas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov, 2)}}</td>
                                                <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov / totalreceitas * 100, 2)}}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="card dre-result-card">
                                <div class="card-header"><i class="fa fa-minus-circle text-despesas"></i> Despesas</div>
                                <div class="card-body table-responsive">
                                    <table class="table table-hover table-sm table-dre responsive">
                                        <tbody>
                                            <tr v-for="(despesa, index) in lstdespesas" v-bind:key="index">
                                                <td class="font-weight-bold text-black-50">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <i class="fa fa-minus-circle despesas" @click.prevent="mtddetalheitem(lstdespesas, index);"></i> {{despesa.descgruconta}}
                                                        </div>
                                                        <template v-if="parseInt(despesa.detalhar) === 1">
                                                            <div class="col-md-2"></div>
                                                            <div class="col-md-10">
                                                                <div class="table-responsive table-borderless">
                                                                    <table class="table table-hover table-sm table-dre responsive">
                                                                        <tbody>
                                                                            <tr v-for="(movimento, indmov) in despesa.movimentos" v-bind:key="indmov">
                                                                                <td class="font-weight-bold text-black-50 dre-subitem">{{movimento.descplano}}</td>
                                                                                <td class="font-weight-bold text-right despesas dre-subitem">{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                                <td width="50" class="text-right text-black-50 dre-subitem">{{mtdformatavalordecimal(movimento.totalmov / despesa.totalmov * 100, 2)}}%</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </td>
                                                <td class="text-right text-despesas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov, 2)}}</td>
                                                <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov / totaldespesas * 100, 2)}}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card dre-footer-card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4 text-center">
                                    <span class="dre-footer-label">Total receitas</span>
                                    <h6 class="text-receitas">{{mtdformatavalordecimal(totalreceitas, 2)}}</h6>
                                </div>
                                <div class="col-md-4 text-center">
                                    <span class="dre-footer-label">Total despesas</span>
                                    <h6 class="text-despesas">{{mtdformatavalordecimal(totaldespesas, 2)}}</h6>
                                </div>
                                <div class="col-md-4 text-center">
                                    <span class="dre-footer-label">Total líquido do exercício</span>
                                    <h6 :class="parseFloat(totaldif) > 0 ? 'text-receitas' : 'text-despesas'">{{mtdformatavalordecimal(totaldif, 2)}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>        
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import util from '../utilitarios/util.js'
    export default {
        name: 'reldemonstrativoresultados',
        components:{
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return { 
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),
                pidfilial           : null,
                pidconta            : null,
                pidgrupoconta       : null,
                pidcentrocusto      : null,
                pdetalhartodos      : false,
                mostrarFiltros      : true,
                
                lstreceitas     : [],        
                lstdespesas     : [],
                totalreceitas   : 0,
                totaldespesas   : 0,  
                totaldif        : 0,
                totalreceber      : 0,
                totalrecebido     : 0,    

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },                
                itensbc : {
                    item1 : {
                        titulo : 'DEMONSTRATIVO DE RESULTADOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                }                
            }
        },
        methods:{   
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},                     
            mtddefinicoesiniais(){
                let vself    = this;

                let retm     = util.pri_ult_diames(new Date, true);
                vself.pdtini = retm.primeirodiames;
                vself.pdtfim = retm.ultimodiames;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilial").val();
				});

                $("#cbconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcontasfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidconta = $("#cbconta").val();
                });                
                $("#cbgrupoconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgruposcontas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupoconta = $("#cbgrupoconta").val();
                });                                      
                $("#cbcentrocusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidcentrocusto = $("#cbcentrocusto").val();
                });            
            
            },
            mtdexecutapesquisa(){
                let vself  = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let loader = vself.$loading.show();
                vself.pdetalhartodos = false;
                let filtro          = ' and mf.dtlancamento between "'+util.InverterData(vself.pdtini)+'" and "'+util.InverterData(vself.pdtfim)+'"';            
                if (vself.pidfilial !==  null){
                    filtro = filtro + ' and cf.idfilial=' + vself.pidfilial;
                }                
                if (vself.pidconta !==  null){
                    filtro = filtro + ' and mf.idconta=' + vself.pidconta;
                }
                if (vself.pidgrupoconta !== null){
                    filtro = filtro + ' and mf.idgrupoconta='+vself.pidgrupoconta;
                }            
                if (vself.pidcentrocusto !== null){
                    filtro = filtro + ' and mf.idcentrocustp='+vself.pidcentrocusto;
                }                
                let parametros = [
                    {parametro: 'op',           valor: 'demonstrativoresultados'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor: filtro},
                    {parametro: 'dtini',        valor: util.InverterData(vself.pdtini)},
                    {parametro: 'dtfim',        valor: util.InverterData(vself.pdtfim)}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstreceitas           = response.data.receitas;
                    vself.totalreceitas         = response.data.totalreceitas;
                    vself.lstdespesas           = response.data.despesas;
                    vself.totaldespesas         = response.data.totaldespesas;
                    vself.totaldif              = parseFloat(vself.totalreceitas) - parseFloat(vself.totaldespesas);
                    vself.totalreceber          = response.data.totalreceber;
                    vself.totalrecebido         = response.data.totalrecebido;
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtddetalheitem(lstitens, indice){
                if (parseInt(lstitens[indice].detalhar) === 0){
                    lstitens[indice].detalhar = 1;                
                }else{
                    lstitens[indice].detalhar = 0;                
                }
            },
            mtddetalhartodos(){
                let vself = this;
                for (let i = 0; i < vself.lstreceitas.length; i++) {
                    vself.lstreceitas[i].detalhar = vself.pdetalhartodos === false ? 0 : 1;                
                }
                for (let x = 0; x < vself.lstdespesas.length; x++) {
                    vself.lstdespesas[x].detalhar = vself.pdetalhartodos === false ? 0 : 1;                
                }            
            },
            mtdimprimir(){
                let vself   = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let det     = !vself.pdetalhartodos ? '0' : '1';
                let filtro          = ' and mf.dtlancamento between "'+util.InverterData(vself.pdtini)+'" and "'+util.InverterData(vself.pdtfim)+'"';            
                if (vself.pidfilial !==  null){
                    filtro = filtro + ' and cf.idfilial=' + vself.pidfilial;
                }                
                if (vself.pidconta !==  null){
                    filtro = filtro + ' and mf.idconta=' + vself.pidconta;
                }
                if (vself.pidgrupoconta !== null){
                    filtro = filtro + ' and mf.idgrupoconta='+vself.pidgrupoconta;
                }            
                if (vself.pidcentrocusto !== null){
                    filtro = filtro + ' and mf.idcentrocustp='+vself.pidcentrocusto;
                } 
                let dtini   = util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilial').select2('data')[0]['text'];
				window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&oprelatorio=2'+
                            '&filtro='+filtro+
                            '&dtini='+dtini+
                            '&dtfim='+dtfim+
                            '&filial='+filial+
                            '&detalhar='+det+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');                
            }           
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('035Z.020Z', vself.$store.state.perfilusuario)) {
                        vself.mtddefinicoesiniais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }            
        },
        computed:{
        },
        watch:{           
        }
    }
</script>
<style>
    .dre-hero{
        margin-top: 6px;
        margin-bottom: 10px;
        border: 1px solid #dce4ef;
        border-top: 4px solid #406e8e;
        border-radius: 14px;
        background: #ffffff;
        color: #23435e;
        box-shadow: 0 6px 22px rgba(42, 70, 96, 0.09);
    }
    .dre-kicker{
        font-size: 11px;
        letter-spacing: .08em;
        text-transform: uppercase;
        color: #5b738e;
        font-weight: 700;
    }
    .dre-title{
        margin-bottom: 4px;
        font-weight: 700;
        font-size: 1.5rem;
        color: #23435e;
    }
    .dre-subtitle{
        margin: 0;
        color: #5e738a;
        font-size: .95rem;
    }
    .dre-action-btn{
        margin-left: 6px;
        margin-top: 4px;
    }
    .dre-filter-card{
        border-radius: 12px;
        border: 1px solid #dce4ef;
        box-shadow: 0 4px 16px rgba(42, 67, 101, 0.08);
        margin-bottom: 12px;
    }
    .dre-filter-card .card-header{
        background: #f4f8fc;
        border-bottom: 1px solid #dce4ef;
        color: #2e4d6d;
        font-weight: 700;
    }
    .dre-filter-card .card-body{
        padding: 12px;
    }
    .dre-switch-wrap{
        margin-top: 0;
        padding: 6px 8px;
        background: #fbfdff;
    }
    #lbldetalhartodos{
        margin-left: 28px;
    }
    .dre-kpis{
        margin: 4px 0 8px 0;
    }
    .dre-kpi-card{
        border-radius: 12px;
        border: 1px solid #e6edf5;
        box-shadow: 0 3px 12px rgba(46, 77, 109, 0.08);
        margin-bottom: 10px;
    }
    .dre-kpi-receita{
        border-left: 4px solid #0acf97;
    }
    .dre-kpi-despesa{
        border-left: 4px solid #fa5c7c;
    }
    .dre-kpi-liquido{
        border-left: 4px solid #406e8e;
    }
    .dre-kpi-title{
        font-size: .82rem;
        text-transform: uppercase;
        color: #6d7f93;
        letter-spacing: .04em;
    }
    .dre-kpi-value{
        margin: 4px 0 0 0;
        font-size: 1.3rem;
        font-weight: 700;
        color: #324f6b;
    }
    .dre-result-card{
        border-radius: 12px;
        border: 1px solid #e1e8f1;
        box-shadow: 0 4px 16px rgba(42, 67, 101, 0.08);
        margin-bottom: 12px;
        height: calc(100% - 12px);
    }
    .dre-result-card .card-header{
        background: #f4f8fc;
        border-bottom: 1px solid #dce4ef;
        color: #2e4d6d;
        font-weight: 700;
    }
    .dre-result-card .card-body{
        padding: 8px 10px;
    }
    .dre-footer-card{
        border-radius: 12px;
        border: 1px solid #e1e8f1;
        box-shadow: 0 4px 16px rgba(42, 67, 101, 0.08);
        margin-bottom: 16px;
    }
    .dre-footer-label{
        font-size: .75rem;
        text-transform: uppercase;
        color: #71879f;
        letter-spacing: .05em;
    }
    .table-dre tr td{
        padding-top: 9px;
        padding-bottom: 9px;
    }
    #tbreceitas tr:first-child td{
        border-top: 0 !important;
    }
    .table-dre tr:last-child td{
        padding-bottom: 0;
    }
    .dre-subitem{
        vertical-align: middle;
        text-align: left;
        font-size: 12px;
        padding-top: 3px;
        padding-bottom: 3px;
    }
    .receitas{
        font-size: 20px;
        cursor: pointer;
        color: #0acf97;
    }
    .despesas{
        font-size: 20px;
        cursor: pointer;
        color: #fa5c7c;
    }
    .text-receitas{
        color: #0acf97;
    }
    .text-despesas{
        color: #fa5c7c;
    }
    .receitas:hover, .despesas:hover{
        filter: brightness(70%) !important;
    }
    @media (max-width: 767px) {
        .dre-title{
            font-size: 1.25rem;
        }
        .dre-action-btn{
            width: 100%;
            margin-left: 0;
            margin-top: 6px;
        }
    }
</style>
